import { modalActions } from './actions-const';

export function setModalOpen() {
  return { type: modalActions.SET_MODAL_OPEN };
}

export function setModalClosed() {
  return { type: modalActions.SET_MODAL_CLOSE };
}

export function setModalStandaloneOpen() {
  return { type: modalActions.SET_MODAL_STANDALONE_OPEN };
}

export function setModalStandaloneClosed() {
  return { type: modalActions.SET_MODAL_STANDALONE_CLOSE };
}
